module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-md"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    Envie um único PDF de scan e uma planilha (.xlsx ou .xls) para vincular esse mesmo arquivo a várias GRVs de\n    uma só vez. A planilha deve ter uma linha de cabeçalho com a coluna:\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    GRVs que já tiverem um arquivo desse tipo são ignoradas (não sobrescreve). Limite de 5MB para a planilha,\n    20MB para o PDF e 2000 linhas por envio. Somente pátios aos quais você tem acesso podem ser alterados.\n  ")]), _vm._v(" "), (!_vm.resultado) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de documento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo),
      expression: "tipo"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "scan_grv"
    }
  }, [_vm._v("Scan GRV")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unificado"
    }
  }, [_vm._v("Documentos Unificados")])])]) : _vm._e(), _vm._v(" "), (!_vm.planilha || !_vm.pdf) ? _c('div', {
    staticClass: "m-b"
  }, [_c('button', {
    staticClass: "btn btn-default m-r-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.escolherPlanilha
    }
  }, [_c('i', {
    staticClass: "fa fa-upload m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.planilha ? 'Trocar planilha' : 'Selecionar planilha') + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.escolherPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.pdf ? 'Trocar PDF' : 'Selecionar PDF de scan') + "\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputPlanilha",
    attrs: {
      "type": "file",
      "accept": ".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    },
    on: {
      "change": _vm.onPlanilhaChange
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputPdf",
    attrs: {
      "type": "file",
      "accept": ".pdf,application/pdf"
    },
    on: {
      "change": _vm.onPdfChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm text-muted"
  }, [(_vm.planilha) ? _c('div', [_c('i', {
    staticClass: "fa fa-file-excel-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.planilha.name))]) : _vm._e(), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.pdf.name))]) : _vm._e()])]) : _c('div', {
    staticClass: "m-b"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.planilha.name))]), _vm._v(" —\n    "), _c('span', [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.pdf.name))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-link",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.trocarArquivos
    }
  }, [_vm._v("\n      (trocar arquivos)\n    ")]), _vm._v(" "), (!_vm.resultado) ? _c('div', {
    staticClass: "m-t-sm"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.analisar
    }
  }, [_c('i', {
    staticClass: "fa fa-search m-r-xs"
  }), _vm._v(" Analisar planilha (pré-visualização)\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm.resultado) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.temResultadoAplicado ? 'alert-success' : 'alert-info'
  }, [_c('strong', [_vm._v(_vm._s(_vm.temResultadoAplicado ? 'Scan vinculado.' : 'Pré-visualização (nada foi gravado ainda).'))]), _vm._v(" "), _c('br'), _vm._v("\n      Total de linhas: " + _vm._s(_vm.resultado.totalLinhas) + " —\n      "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.resultado.totalAtualizadas) + " para vincular")]), _vm._v(" —\n      "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.resultado.totalErros) + " com erro")])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "45vh",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-condensed b-t b-light"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.linhas), function(linha) {
    return _c('tr', {
      key: linha.linha
    }, [_c('td', [_vm._v(_vm._s(linha.linha))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.numero))]), _vm._v(" "), _c('td', {
      class: _vm.corStatus(linha.status)
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.iconeStatus(linha.status)
    }), _vm._v(" " + _vm._s(linha.status) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.mensagem))])])
  }), 0)])]), _vm._v(" "), (_vm.temPreview) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.podeConfirmar || _vm.loading
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_c('i', {
    staticClass: "fa fa-check m-r-xs"
  }), _vm._v(" Confirmar e vincular em " + _vm._s(_vm.resultado.totalAtualizadas) + " GRV(s)\n      ")]), _vm._v(" "), (!_vm.podeConfirmar) ? _c('span', {
    staticClass: "text-muted m-l-sm"
  }, [_vm._v("Nenhuma linha válida para aplicar.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.temResultadoAplicado) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Fechar")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "text-muted"
  }, [_c('li', [_c('strong', [_vm._v("GRV")]), _vm._v(" (ou "), _c('strong', [_vm._v("numero")]), _vm._v(") — obrigatória, número da GRV")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Linha")]), _vm._v(" "), _c('th', [_vm._v("GRV")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Mensagem")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fee0cc36","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/automacoes/components/ScanEmMassa.vue
// module id = 2100
// module chunks = 18